import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/data-catalog/$catalogId")({
  beforeLoad: requireSuperAdmin(),
  component: () => <Outlet />,
});
